function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      // if (detailsElement.classList.contains('dropdown')) return;
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        // parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  /*
  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }
  */

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('mobile-menu-nav', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    if ( focus ) window.pauseAllMedia();
    
    if (!this.getAttribute('loaded')) {
      const node = document.createElement('div');
      node.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(node.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    } else {
      // const node = document.createElement('div');
      // const template = this.querySelector('template').node.firstElementChild;
      const content = this.querySelector('video, model-viewer, iframe');
      if ( content ) {
        // node.replaceChildren(template);
        
        
        // const deferredElement = this.replaceChildren(node.querySelector('video, model-viewer, iframe'));
        if (focus) content.focus();
        if (content.nodeName == 'VIDEO' && content.getAttribute('autoplay')) {
          // force autoplay for safari
          content.play();
        }
        
      }
      
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = true;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    console.log("nextButton:", this.nextButton);
    console.log("prevButton:", this.prevButton);
    this.debouncing = false;

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    // this.slider.addEventListener('mousedown', this.startDrag.bind(this));
    // this.slider.addEventListener('touchstart', this.startDrag.bind(this));
    // document.addEventListener('mousemove', this.moveDrag.bind(this));
    // document.addEventListener('touchmove', this.moveDrag.bind(this));
    // document.addEventListener('mouseup', this.endDrag.bind(this));
    // document.addEventListener('touchend', this.endDrag.bind(this));

    // a) on scroll (with rAF to keep it light)
    this._raf = null;
    this.slider.addEventListener('scroll', () => {
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(() => this.detectSlideChange());
    }, { passive: true });

    // b) on scrollend (nice-to-have; fallback isn’t required because (a) covers it)
    if ('onscrollend' in this.slider) {
      this.slider.addEventListener('scrollend', () => this.detectSlideChange());
    }

    const ro = new ResizeObserver(() => {
      this.sliderItems = Array.from(this.querySelectorAll('[id^="Slide-"]')).filter(el => el.clientWidth > 0);
      if (this.pageTotalElement) this.pageTotalElement.textContent = this.sliderItems.length;
      this.detectSlideChange();
    });
    ro.observe(this.slider);

    // ⭐ After we wire everything up, try to jump to the active slide
    // (constructor is usually early, but we can attempt here in case DOM is already laid out)
    this.scrollToActiveSlide();
    this.mediaSize();
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(el => el.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
    this.updateNavigationState(); 

    // ⭐ Re-run scroll after layout calc (useful on first render / resize)
    this.scrollToActiveSlide();
    this.mediaSize();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage !== previousPage) {
      const currentSlide = this.sliderItemsToShow[this.currentPage - 1];

      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: currentSlide
        }
      }));

      // ✅ Sync with thumbnails only if slider is inside a media-gallery
      if (this.closest('media-gallery')) {
        const activeMediaId = currentSlide.dataset.mediaId;
        const sectionId = this.id.replace('GalleryViewer-', '');
        const thumbSwiperEl = document.querySelector(`#ThumbnailSwiper-${sectionId}`);
        if (thumbSwiperEl) {
          const thumbSlides = thumbSwiperEl.querySelectorAll('.swiper-slide');

          thumbSlides.forEach(slide => {
            slide.classList.remove('swiper-slide-active');
            const btn = slide.querySelector('button');
            if (btn) btn.removeAttribute('aria-current');
          });

          const activeThumb = thumbSwiperEl.querySelector(`[data-target="${activeMediaId}"]`);
          if (activeThumb) {
            activeThumb.classList.add('swiper-slide-active');
            const button = activeThumb.querySelector('button');
            if (button) button.setAttribute('aria-current', 'true');
          }
        }
      }
    }
    this.updateNavigationState(); 

    if (this.enableSliderLooping) return;
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = parseInt(event.currentTarget.dataset.step || 1, 10);
    const isNext = event.currentTarget.name === 'next';

    if(this.sliderItemOffset == undefined) {
      this.resetPages()
    }

    const newPosition = isNext
      ? this.slider.scrollLeft + (step * this.sliderItemOffset)
      : this.slider.scrollLeft - (step * this.sliderItemOffset);

    console.log(newPosition);

    const totalScrollableWidth = this.slider.scrollWidth;
    const sliderWidth = this.slider.offsetWidth;

    console.log(sliderWidth, isNext, newPosition,totalScrollableWidth, this.sliderItemOffset,step,this.slider.scrollLeft);

    if (isNext && newPosition >= totalScrollableWidth - sliderWidth) {
      this.slideScrollPosition = 0;
    } else if (!isNext && this.slider.scrollLeft <= 0) {
      this.slideScrollPosition = totalScrollableWidth - sliderWidth;
    } else {
      this.slideScrollPosition = newPosition;
    }

    console.log(this.slideScrollPosition);

    this.slider.scrollTo({ left: this.slideScrollPosition, behavior: 'smooth' });

    if (isNext) this.prevButton.disabled = false;
    if (!this.enableSliderLooping) {
      this.prevButton.disabled = this.slideScrollPosition <= 0;
      this.nextButton.disabled = this.slideScrollPosition >= totalScrollableWidth - sliderWidth;
    }
    this.slider.scrollTo({ left: this.slideScrollPosition, behavior: 'smooth' });
    this.detectSlideChange();
  }

  // ⭐ New helper: find .activeslide and scroll it into view
  scrollToActiveSlide() {
    if (!this.slider) return;

    const active = this.querySelector('.is-active');
    if (!active) return;

    // If it's already fully visible, do nothing
    if (this.isSlideVisible && this.isSlideVisible(active)) return;
    this.slider.scrollTo({
      left: active.offsetLeft,
      behavior: 'instant'
    });

    // Update counters/currentPage after jump
    this.update();
  }

  mediaSize() {
    const images = this.querySelectorAll('.slider__slide');
    images.forEach((media) => {
      media.style.opacity = '1';
    });
  }

  updateNavigationState() {
  if (!this.prevButton || !this.nextButton) return;

  const totalSlides = this.sliderItemsToShow.length;

  // All slides fit — no navigation needed
  if (totalSlides <= this.slidesPerPage) {
    this.prevButton.disabled = true;
    this.nextButton.disabled = true;

    // optional: hide instead of disable
    // this.prevButton.hidden = true;
    // this.nextButton.hidden = true;
    return;
  }

  // Otherwise restore visibility
  // this.prevButton.hidden = false;
  // this.nextButton.hidden = false;

  if (this.enableSliderLooping) {
    this.prevButton.disabled = false;
    this.nextButton.disabled = false;
    return;
  }

  const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;

  this.prevButton.disabled = this.slider.scrollLeft <= 0;
  this.nextButton.disabled = this.slider.scrollLeft >= maxScroll;
}

  connectedCallback() {
    if (this.dataset.reset_scroll === "true") this.slider.scrollLeft = 0;

    // ⭐ Final safety: run once the element is actually in DOM
    this.scrollToActiveSlide();
  }

  // (assuming you already have startDrag/moveDrag/endDrag in your real file;
  // they weren't in the snippet, so not repeating them here)

  // Put this inside your SliderComponent class
  detectSlideChange() {
    if (!this.slider || !this.sliderItems?.length) return;

    const containerRect = this.slider.getBoundingClientRect();
    const containerCenterX = containerRect.left + containerRect.width / 2;

    let bestIdx = -1;
    let bestDist = Infinity;

    for (let i = 0; i < this.sliderItems.length; i++) {
      const el = this.sliderItems[i];
      const r = el.getBoundingClientRect();
      const overlap = Math.max(0, Math.min(r.right, containerRect.right) - Math.max(r.left, containerRect.left));
      if (overlap <= 0) continue; // ignore slides not on-screen at all

      const centerX = r.left + r.width / 2;
      const dist = Math.abs(centerX - containerCenterX);

      if (dist < bestDist) {
        bestDist = dist;
        bestIdx = i;
      }
    }

    if (bestIdx === -1) return; // nothing visible

    if (bestIdx !== this._activeIndex) {
      this._activeIndex = bestIdx;
      const current = this.sliderItems[bestIdx];

      // classes + aria
      this.sliderItems.forEach((el, i) => {
        el.classList.toggle('is-active', i === bestIdx);
        if (i === bestIdx) el.setAttribute('aria-current', 'true');
        else el.removeAttribute('aria-current');
      });

      // counters
      if (this.currentPageElement) this.currentPageElement.textContent = String(bestIdx + 1);
      if (this.pageTotalElement)   this.pageTotalElement.textContent   = String(this.sliderItems.length);
      
      
      this.playActiveMedia(current);

      // fire on the scroll root (so media-gallery's viewer listener catches it)
      this.slider.dispatchEvent(new CustomEvent('slideChanged', {
        bubbles: true,
        composed: true,
        detail: {
          currentPage: bestIdx + 1,
          currentElement: current
        }
      }));
    }
    this.updateNavigationState(); 
  }
  
  
  pauseAllMedia() {
    this.sliderItems.forEach((item) => {
      const deferredMedia = item.querySelector('.deferred-media');
      if (deferredMedia) {
        const video = deferredMedia.querySelector('video');
        if ( video ) video.pause();
      }
    });
  }
  
  playActiveMedia(activeItem) {
    this.pauseAllMedia();
    
    const deferredMedia = activeItem.querySelector('.deferred-media');
    if (deferredMedia) {
      if (deferredMedia.getAttribute('loaded') === 'true') {
        const video = deferredMedia.querySelector('video');
        if ( video ) video.play();
        
      } else {
        deferredMedia.loadContent(false);
      }
    }
  }
  
  
}

customElements.define('slider-component', SliderComponent);


class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = false;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.renderSocialProofing();
    }

    // this.renderSocialProofing();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  
  async renderSocialProofing() {
    const product_id = this.dataset.id;
    const handle = this.dataset.handle

    if (!(document.querySelector('.social-proofing'))) {
      return;
    }

    const variantId = document.querySelector('input.product-variant-id').value;
    
    try {
      const response = await fetch(window.Shopify.routes.root + `products/${handle}?sections=social-proofing&product_id=${product_id}&variant=${variantId}`);
    
      if (response.ok) {
        const data = await response.json();
        let html = data["social-proofing"];
      
        const scripts_to_run = html.match(/<script spf>([\s\S]*?)<\/script>/gm);
        const scripts = [];
  
        scripts_to_run.forEach(script => {
        script = script.replace("</script>", "").replace("<script spf>", "");
  
        scripts.push(script);
      });

        const newDiv = document.createElement("div");
        newDiv.innerHTML = html;

        document.querySelector('.social-proofing').innerHTML = html;
        
        scripts.forEach(script_to_eval => {
          new Function(script_to_eval)();
        });
        
      } else {
        throw new Error('Error: ' + response.status);
      }
    } catch (error) {
      console.error(error);
    }

    document.dispatchEvent(new Event("product:swapped"));
  }
  
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    const wishListIcons = document.querySelectorAll('.swym-add-to-wishlist-view-product');
    if (wishListIcons.length > 0) {
      wishListIcons.forEach(icon => {
        icon.setAttribute('data-variant-id', `${this.currentVariant.id}`);
      });
      document.dispatchEvent(new CustomEvent("swym:product-pdp-loaded"));
      document.dispatchEvent(new CustomEvent("swym:quick-modal-loaded"));
    }
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});

        if (window.uaSwapTracking) {
          var _h1 = document.querySelector('.product__title h1');
          window.uaSwapTracking.fireSwapEvent({
            variantId: this.currentVariant.id,
            productId: this.dataset.id || (window.pageinfo ? window.pageinfo.id : null),
            sku: this.currentVariant.sku,
            productName: _h1 ? _h1.innerText.trim() : (window.pageinfo ? window.pageinfo.title : null),
            variantName: this.currentVariant.title,
            price: this.currentVariant.price != null ? this.currentVariant.price / 100 : null,
            compareAtPrice: this.currentVariant.compare_at_price != null ? this.currentVariant.compare_at_price / 100 : null,
            currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : null,
            brand: window.pageinfo ? window.pageinfo.vendor : null,
            category: window.pageinfo ? window.pageinfo.type : null
          });
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          // Remove placeholder if needed
          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          // Cards loaded
          const cards = html.querySelectorAll('.grid__item');

          // Feature card adjustments
          const feature_card_enabled = this.dataset.feature_card_enabled === 'true';
          if (feature_card_enabled) {
            const columns_desktop = parseInt(this.dataset.columns_desktop);
            const cards_fit_desktop = cards.length <= columns_desktop;
            const feature_wrap_el = document.querySelector(`#shopify-section-${this.dataset.section_id} .carousel__feature-wrap`);
            if (cards_fit_desktop) {
              feature_wrap_el.classList.add('carousel__feature-wrap--cards-fit-desktop');
            }
          }

          const parent_section = document.getElementById(this.dataset.section_id);

          // Recently viewed logic
          const hide_recently_tab = this.dataset.hide_recently_tab === 'true';
          const product_handle = this.dataset.product_handle;
          const product_handles_list = localStorage.getItem("shopify_recently_viewed");
          const no_recently_viewed = (!product_handles_list || product_handles_list === "" || product_handles_list === product_handle);

          if (cards.length > 0) {
            // Mark as loaded
            this.classList.add('product-recommendations--loaded');
          } else if (hide_recently_tab || no_recently_viewed) {
            // Hide the whole carousel if no items
            if (parent_section) {
              parent_section.classList.add('hidden');
            }
          } else {
            // Hide only product recommendations, show recently viewed
            const recommendationsEl = parent_section.querySelector('product-recommendations');
            const recentlyEl = parent_section.querySelector('recently-viewed');
            const recommendations_tab = parent_section.querySelector('.product-recommendations-tab');
            const recently_tab = parent_section.querySelector('.recently-viewed-tab');

            if (recommendations_tab) recommendations_tab.classList.add('hidden');
            if (recently_tab) recently_tab.classList.add('hidden');
            if (recommendationsEl) recommendationsEl.classList.remove('active');
            if (recentlyEl) recentlyEl.classList.add('active');
          }

          // -------------------------------
          // Initialize Swiper after content is loaded
          // -------------------------------
          const container = this.querySelector('.swiper-container');
          if (container) {
            const colsDesktop = parseFloat(this.dataset.columns_desktop || 4);
            const colsDesktopAdjusted = parseFloat(this.dataset.columns_desktop_adjusted || colsDesktop);
            const colsMobile = parseFloat(this.dataset.columns_mobile || 1);
            const colsMobileAdjusted = parseFloat(this.dataset.columns_mobile_adjusted || colsMobile);
            const section_id = this.dataset.section_id.replace("shopify-section-", "");
            const prevBtn = document.querySelector(`.swiper-buttons-${section_id} .slider-button--prev`);
            const nextBtn = document.querySelector(`.swiper-buttons-${section_id} .slider-button--next`);
            const parentButtons = container.closest('.slider-buttons-parent') || container.parentElement;
            let counterCurrent = null;
            let counterTotal = null;
            if (parentButtons) {
              counterCurrent = parentButtons.querySelector('.slider-counter--current');
              counterTotal = parentButtons.querySelector('.slider-counter--total');
              if (counterTotal && counterTotal.textContent.trim() === '') {
                counterTotal.textContent = container.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
              }
            }

            const swiper = new Swiper(container, {
              slidesPerView: colsMobileAdjusted || 1,
              spaceBetween: 30,
              loop: false,
              navigation: {
                nextEl: nextBtn || null,
                prevEl: prevBtn || null
              },
              breakpoints: {
                768: { slidesPerView: Math.min(Math.max(1, Math.floor(colsDesktop / 2) || 2), colsDesktop) },
                1300: { slidesPerView: colsDesktopAdjusted }
              },
              on: {
                init: function() { 
                  updateCounter(this, counterCurrent, counterTotal); 
                  this.el.querySelectorAll('.slider__slide').forEach((media) => {
                    media.style.opacity = '1';
                  });
                },
                slideChange: function() { updateCounter(this, counterCurrent, counterTotal); },
                resize: function() { updateCounter(this, counterCurrent, counterTotal); }
              }
            });

            function updateCounter(swpr, currentEl, totalEl) {
              if (!currentEl && !totalEl) return;
              const realIndex = swpr.realIndex !== undefined ? swpr.realIndex : swpr.activeIndex || 0;
              const displayIndex = realIndex + 1;
              if (currentEl) currentEl.textContent = displayIndex;
              if (totalEl) totalEl.textContent = swpr.slides ? swpr.slides.length : container.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
            }
          }
          // -------------------------------
        })
        .catch(e => console.error(e));
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);






class UpsellProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {

          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('upsell-product-recommendations');
          if (recommendations) {
            if(recommendations.innerHTML.trim().length == 0){
              fetch(this.dataset.fallbackurl)
              .then(response => response.text())
              .then(text => {
                html.innerHTML = text;
                const recommendations = html.querySelector('upsell-product-recommendations');
                
                this.innerHTML = recommendations.innerHTML;
                if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                  this.remove();
                }
                if (html.querySelector('.grid__item')) {
                  this.classList.add('product-recommendations--loaded');
                }
              });
            }else{
              this.innerHTML = recommendations.innerHTML;
              if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                this.remove();
              }
              if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
              }
            }
          }

        })
        .catch(e => {
          console.error(e);
        });

  }
}

customElements.define('upsell-product-recommendations', UpsellProductRecommendations);


class CrossellProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {

          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('crossell-product-recommendations');

          if (recommendations) {
            if(recommendations.innerHTML.trim().length == 0){
              fetch(this.dataset.fallbackurl)
              .then(response => response.text())
              .then(text => {
                html.innerHTML = text;
                const recommendations = html.querySelector('crossel-product-recommendations');
                this.innerHTML = recommendations.innerHTML;
                if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                  this.remove();
                }
                if (html.querySelector('.grid__item')) {
                  this.classList.add('product-recommendations--loaded');
                }
              });
            }else{
              this.innerHTML = recommendations.innerHTML;
              if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                this.remove();
              }
              if (html.querySelector('.grid__item')) {
                this.classList.add('product-recommendations--loaded');
              }
            }
          }

        })
        .catch(e => {
          console.error(e);
        });

  }
}

customElements.define('crossell-product-recommendations', CrossellProductRecommendations);

/*

class ShopTheLook extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

    fetch(this.dataset.url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const sliderComponent = html.querySelector('slider-component');
      const recAttr = sliderComponent ? sliderComponent.getAttribute('data-recommendations') : null;

      if (!recAttr) {
        console.warn("No recommendations found, aborting ShopTheLook update.");
        return;
      }

    const handles = recAttr
      .split(',')
      .map(h => h.trim())
      .filter(Boolean);
        const carousel = this.querySelector('.slider');
        const currentCards = carousel ? carousel.querySelectorAll('.grid__item.slider__slide') : [];
        const currentCount = currentCards.length;
        const lastSlide = currentCards[currentCards.length - 1];

        console.log("Current Carousel", carousel);

        let templateId = '';
        let lastIndex = 0;

        if (lastSlide) {
          const match = lastSlide.id.match(/-(\d+)$/);
          lastIndex = match ? parseInt(match[1], 10) : 0;
          templateId = lastSlide.id.replace(/-\d+$/, '');
        }

        const existingHandles = Array.from(currentCards).map(el => el.getAttribute('data-product-handle'));

        const handlesToAdd = handles.filter(h => !existingHandles.includes(h));
        const needed = Math.max(0, 6 - currentCount);
        const handlesToFetch = handlesToAdd.slice(0, needed);

        return Promise.all(
          handlesToFetch.map(handle =>
            fetch(`/products/${handle}?section_id=recommended-product-cards`)
              .then(res => res.text())
              .then(htmlText => {
                const doc = new DOMParser().parseFromString(htmlText, 'text/html');
                return doc.body.firstElementChild.querySelector("product-card");
              })
          )
        ).then(fetchedCards => {
          fetchedCards.forEach((card, i) => {
            if (!card) return;
            const cardClone = card.cloneNode(true);
            const li = document.createElement('li');
            li.className = 'grid__item slider__slide';
            li.dataset.productHandle = handlesToFetch[i];
            li.id = `${templateId}-${lastIndex + i + 1}`;
            li.appendChild(cardClone);

            carousel.appendChild(li);
            });

          // --- Keep all existing functionality ---
          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('shop-look--loaded');
          }

          const shopLookSlider = this.querySelector('shop-look ul.slider');
          const shopLookSliderChildren = shopLookSlider.querySelectorAll('.grid__item.slider__slide');

          if (shopLookSliderChildren.length > 0 || Shopify.designMode) {
            this.closest('.carousel').classList.remove('hidden');
          } else {
            this.closest('.carousel').classList.add('hidden');
          }

          const sliderEl = this.closest('slider-component') || this.querySelector('slider-component');
          if (sliderEl && sliderEl.resetPages === 'function') {
            sliderEl.resetPages();
            
            if (typeof sliderEl.update === 'function') sliderEl.update();
          } else {
            window.dispatchEvent(new Event('resize'));
          }

          // --- Refresh Yotpo widgets ---
          if (window.Yotpo && window.Yotpo.API) {
            const api = new window.Yotpo.API(window.yotpo);
            if (api) api.refreshWidgets();
          }
        });
      })
      .catch(e => console.error(e));
  }
}

customElements.define('shop-look', ShopTheLook);
*/

class RecentlyViewed extends HTMLElement {
  /*
    data-full_width="{{ full_width }}"
    data-max_cards_to_output="{{ max_cards_to_output }}"
    data-sectionid="{{ section.id }}"
    data-columns_desktop="{{ columns_desktop }}"
    data-columns_mobile="{{ columns_mobile }}"
    data-feature_card_enabled="{{ section.settings.feature_card_enabled }}"
    data-recently_is_only_tab="{{ recently_is_only_tab }}"
    data-on_product_page="{{ on_product_page }}"
  */

  constructor() {

    super();
  }

  config = {
    maxToShow: parseInt(this.dataset.max_cards_to_output),
    minToShow: 1,
    howManyToStoreInMemory: parseInt(this.dataset.max_cards_to_output),
    numberProducts: 0,
    onComplete: null
  };
  productHandleQueue = [];

  cookie = {
    name: 'shopify_recently_viewed',
    write: function (recentlyViewed) {
      localStorage.setItem(this.name, recentlyViewed.join(','));
    },
    read: function () {
      let recentlyViewed = [];
      let cookieValue = localStorage.getItem(this.name);
      if (cookieValue) {
        recentlyViewed = cookieValue.split(',');
      }
      return recentlyViewed;
    },
    destroy: function () {
      localStorage.removeItem(this.name);
    },
    remove: function (productHandle) {
      let recentlyViewed = this.read();
      let position = recentlyViewed.indexOf(productHandle);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    }
  };

  finalize = () => {

    // Add and remove classes that depend on the number of cards

    // Get elements
    const sliderComponent = this.querySelector('slider-component');
    const sliderUL = this.querySelector('slider-component ul.slider');
    const featureWrap = document.querySelector(`#shopify-section-${this.dataset.section_id}.carousel__feature-wrap`);
    const max_cards_to_output = this.config.maxToShow;

    // Hide buttons if cards fit
    const columns_desktop = parseInt(this.dataset.columns_desktop);
    const columns_mobile = parseInt(this.dataset.columns_mobile);
    let cards_fit_desktop = sliderUL.children.length <= columns_desktop;
    const cards_fit_mobile = sliderUL.children.length <= columns_mobile;
    const feature_card_enabled = this.dataset.feature_card_enabled === 'true';

    if( feature_card_enabled ) {
      cards_fit_desktop = sliderUL.children.length < columns_desktop;
    }else{
      cards_fit_desktop = sliderUL.children.length <= columns_desktop
    }


    if( cards_fit_desktop ) {
      sliderComponent.classList.add('slider-component--cards-fit-desktop');
    }else{
      sliderComponent.classList.remove('slider-component--cards-fit-desktop');
    }

    if( cards_fit_mobile ) {
      sliderComponent.classList.add('slider-component--cards-fit-mobile');
    }else{
      sliderComponent.classList.remove('slider-component--cards-fit-mobile');
    }

    if( featureWrap ) {
      if( cards_fit_desktop ) {
        featureWrap.classList.add('carousel__feature-wrap--cards-fit-desktop');
      }else{
        featureWrap.classList.remove('carousel__feature-wrap--cards-fit-desktop');
      }
    }

    if( this.dataset.full_width === 'true' ) {
      // set full_width class on parent
      sliderComponent.classList.add('slider-component-full-width');
      sliderComponent.classList.remove('page-width');

      // Add dummy list items for padding
      // const li = document.createElement('li');
      // li.setAttribute('aria-hidden', 'true');
      // li.setAttribute('class', 'slider__slide first-dummy');
      // li.innerHTML = '<!--fake padding-->';

      const li_2 = document.createElement('li');
      li_2.setAttribute('aria-hidden', 'true');
      li_2.setAttribute('class', 'slider__slide last-dummy');
      li_2.innerHTML = '<!--fake padding-->';

      sliderUL.prepend(li);
      sliderUL.appendChild(li_2);
    } else {
      sliderComponent.classList.remove('slider-component-full-width');
      sliderComponent.classList.add('page-width');
    }

    sliderUL.scrollLeft = 0;
    this.classList.add('recently-viewed--loaded');

  };

  getRecentProducts = async () => {
    let productHandle;
  
    // Exclude the current product if on a product page
    if (window.location.pathname.includes('/products/')) {
      const match = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/);
      if (match && match[1]) {
        productHandle = match[1];
        this.productHandleQueue = this.productHandleQueue.filter(
          handle => handle !== productHandle
        );
      }
    }
  
    // Not enough products to show
    if (this.productHandleQueue.length < this.config.minToShow) {
      return;
    }
  
    // Limit the number of products to show
    this.config.numberProducts = this.productHandleQueue.length;
    this.productHandleQueue.length = this.config.maxToShow;
  
    // Build Section Rendering API URL
    const sectionUrl = `/?sections=recently-viewed&handles=${this.productHandleQueue.join(',')}`;
  
    try {
      const response = await fetch(sectionUrl);
      const data = await response.json();
      const html = data['recently-viewed'];
  
      const targetContainer = document.querySelector(
        `#shopify-section-${this.dataset.sectionid} recently-viewed`
      );
  
      if (targetContainer) {
        targetContainer.innerHTML = html;
        this.finalize(); // Call any post-render logic
      } else {
        console.warn('recently-viewed container not found');
      }
    } catch (err) {
      console.warn('Failed to load recently viewed products:', err);
    }
  };
  

  recordRecentlyViewed = values => {
    let vals = values || {};
    let recentlyViewed = this.cookie.read();
    let productHandle;
    let position;

    // Update defaults.
    this.config = {...this.config, ...vals};

    // If we are on a product page.
    if (window.location.pathname.indexOf('/products/') !== -1) {

      productHandle = window.location.pathname.match(
        /\/products\/([a-z0-9\-]+)/
      )[1];

      position = recentlyViewed.indexOf(productHandle);

      if (position === -1) {

        recentlyViewed.unshift(productHandle);

        recentlyViewed = recentlyViewed.splice(
          0,
          this.config.howManyToStoreInMemory
        );
      } else {

        recentlyViewed.splice(position, 1);
        recentlyViewed.unshift(productHandle);
      }

      this.cookie.write(recentlyViewed);
    }
  }

  showRecentlyViewed = parameters => {

    // Hide whole carousel if only tab and nothing to show
    const recently_is_only_tab = this.dataset.recently_is_only_tab === 'true';
    const sectionid = this.dataset.section_id;
    const carousel = document.querySelector('.carousel.section-'+sectionid);
    const product_handles_list = localStorage.getItem("shopify_recently_viewed");
    if( this.dataset.on_product_page === 'true' ) {
      const product_handle = this.dataset.product_handle;
      const no_recently_viewed = ( !product_handles_list || product_handles_list == "" || product_handles_list == product_handle );
      if( recently_is_only_tab && no_recently_viewed && carousel) {
        carousel.classList.add('hidden');
      } else {
        const no_recently_viewed = ( !product_handles_list || product_handles_list == "" );
        if( recently_is_only_tab && no_recently_viewed && carousel) {
          carousel.classList.add('hidden');
        }
      }
    }


    let params = parameters || {};
    // Update defaults.
    this.config = {...this.config, ...params};

    // Read cookie.
    this.productHandleQueue = this.cookie.read();

    if (this.productHandleQueue === null || this.productHandleQueue === undefined) {
      return false;
    }

    this.config.maxToShow = Math.min(this.productHandleQueue.length, this.config.maxToShow);

    if (this.config.maxToShow) {
      this.getRecentProducts().then();
    }
  }

  connectedCallback() {
    this.showRecentlyViewed();
    this.recordRecentlyViewed();
  }
}

customElements.define('recently-viewed', RecentlyViewed);


window.handleize = str => {
  str = str.trim() // remove whitespace from string
  str = str.toLowerCase() // Set to lowercase
  str = str.replace(/\s+/g, '-') // Replace spaces
  str = str.replace(/&/g, '-') // Replace ampersands
  str = str.replace(/:/g, '-') // Replace colons
  str = str.replace(/----/g, '-') // Replace four dashes
  str = str.replace(/---/g, '-') // Replace triple dashes
  str = str.replace(/--/g, '-') // Replace double dashes
  str = str.replace(/"/g, '') // Removed double quotes
  return str;
}

document.querySelectorAll('.findation-trigger').forEach(el => {
  if(Findation) {
    el.addEventListener('click', (e) => {
        e.preventDefault();
        Findation.openWidget();
    });
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const thumbnailSwiperWrap = document.querySelector('.thumbnail-swiper-wrap');

  if (!thumbnailSwiperWrap) return;

  const thumbSlides = thumbnailSwiperWrap.querySelectorAll('.swiper-slide');
  const mainGallery = document.querySelector('media-gallery');
  const mainSlides = mainGallery ? mainGallery.querySelectorAll('[data-media-id]') : [];

  thumbSlides.forEach((thumbSlide) => {
    const button = thumbSlide.querySelector('button');
    if (!button) return;

    button.addEventListener('click', () => {
      const targetId = thumbSlide.dataset.target;

      // 1️⃣ Update thumbnail active classes
      thumbSlides.forEach(slideItem => {
        slideItem.classList.remove('swiper-slide-active');
        const btn = slideItem.querySelector('button');
        if (btn) btn.removeAttribute('aria-current');
      });
      thumbSlide.classList.add('swiper-slide-active');
      button.setAttribute('aria-current', 'true');

      // 2️⃣ Update main gallery
      if (!mainSlides.length) return;

      mainSlides.forEach(slide => slide.classList.remove('is-active'));

      const activeMainSlide = mainGallery.querySelector(`[data-media-id="${targetId}"]`);

      if (activeMainSlide) {
        activeMainSlide.classList.add('is-active');

        // Optional: scroll main slide into view if horizontal gallery
        activeMainSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

        const deferredMedia = activeMainSlide.querySelector('.deferred-media .deferred-media__poster');
        if (deferredMedia) deferredMedia.click();
      }
    });
  });
});
